(function () {
    'use strict';

    var app = angular.module('app');

    angular.forEach(window.ngAppSettings, function (value, key) {
        app.value(key, value);
    });
})();
